interface ExportEligibleFile {
  _id?: string;
  isExportAllowed?: boolean;
  documentationId?: string;
}

/**
 * Whether the file's owner/permissions allow export at all.
 * `isExportAllowed` defaults to `true` when not explicitly set to `false`.
 */
export function isFileExportAllowed(
  file: Pick<ExportEligibleFile, 'isExportAllowed'> | null | undefined
): boolean {
  return file?.isExportAllowed !== false;
}

/**
 * Full eligibility check: file is persisted, export is allowed,
 * and it hasn't already been exported to documentation.
 */
export function canExportFileToDocumentation(
  file: ExportEligibleFile | null | undefined
): boolean {
  if (!file?._id) return false;
  return isFileExportAllowed(file) && !file.documentationId;
}
